import { AreaPage } from '@kanos/web-core';
import { createFileRoute } from '@tanstack/react-router';
import { DutyTabs } from '../firm/duty-tabs';
import { ServiceProvidersCard } from '../firm/service-providers-card';

export const Route = createFileRoute('/obligations/providers')({
  component: Providers,
});

/** Who works for the firm from outside (ADR-083 § 5). */
function Providers() {
  return (
    <AreaPage title="Pflichten">
      <DutyTabs current="providers" />
      <ServiceProvidersCard />
    </AreaPage>
  );
}
